import { CustomersPage } from 'pages/custom/CustomersPage';
import { FestivalAtmosfera } from 'pages/custom/FestivalAtmosfera';
import { FestivalPageCZ } from 'pages/custom/FestivalPageCZ';
import { FestivalPageEN } from 'pages/custom/FestivalPageEN';
import { FestivalPageNO } from 'pages/custom/FestivalPageNO';
import { AquanorPage } from 'pages/special/AquanorPage';
import { DeleteDetailsPage } from 'pages/special/DeleteDetailsPage';
import { ImageUploaderPage } from 'pages/special/ImageUploaderPage';
import { ImportDetailsPage } from 'pages/special/ImportDetailsPage';
import { ImportKmzPage } from 'pages/special/ImportKmzPage';
import { ImportProgramPage } from 'pages/special/ImportProgramPage';
import { OrienteeringPage } from 'pages/special/OrienteeringPage';
import { OrienteeringPage2 } from 'pages/special/OrienteeringPage2';
import { RedirectPage } from 'pages/special/RedirectPage';
import { UpdateSeafoodProgram } from 'pages/special/UpdateSeafoodProgram';
import { TestPage } from 'pages/test/TestPage';
import { Route } from 'react-router-dom';

export default [
    <Route path="/s/orienteering" element={<OrienteeringPage />} key="100" />,
    <Route path="/s/test" element={<TestPage />} key="101" />,
    <Route path="/demo/festival/cz" element={<FestivalPageCZ />} key="105" />,
    <Route path="/demo/festival/no" element={<FestivalPageNO />} key="106" />,
    <Route path="/demo/festival/en" element={<FestivalPageEN />} key="107" />,
    <Route
        path="/map/4a722a16-2518-4d61-a418-7b8a4761de6c/:detailId?"
        element={<FestivalAtmosfera />}
        key="108"
    />,
    <Route path="/m/customers/:detailId?" element={<CustomersPage />} key="109" />,

    <Route path="/s/orienteering2" element={<OrienteeringPage2 />} key="110" />,
    <Route path="/s/imageuploader" element={<ImageUploaderPage />} key="111" />,
    <Route path="/s/import" element={<ImportKmzPage />} key="112" />,
    <Route path="/r/:id" element={<RedirectPage />} key="113" />,
    <Route path="s/importdetails" element={<ImportDetailsPage />} key="114" />,
    <Route path="s/importprogram" element={<ImportProgramPage />} key="115" />,
    <Route path="s/deletedetails" element={<DeleteDetailsPage />} key="116" />,
    <Route path="s/updateseafoodprogram" element={<UpdateSeafoodProgram />} key="117" />,
    <Route path="/m/aquanor" element={<AquanorPage />} key="118" />,
    <Route path="/m/aquanor/:id" element={<AquanorPage />} key="11" />
];
